import React, { useState, useContext } from "react";
import { Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { Option } from "react-bootstrap-typeahead/types/types";
import { useTranslation } from "react-i18next";
import { Congregation } from "../../../../../types/scheduling/weekend";
import { HGContext } from "../../../../../helpers/globals";
import { CongWeekendMeetingTime } from "../../wm_common";

interface CongregationDropdownProps {
  congs: Congregation[];
  selected?: number;
  setCong: (congId: number) => void;
  excludeMyCong?: boolean;
  override?: number;
  langGroupId?: number;
  hideDOW?: boolean;
  hideMeetingTime?: boolean;
  autoFocus?: boolean;
}

export const CongregationDropdown: React.FC<CongregationDropdownProps> = (props) => {
  const { t, i18n } = useTranslation();
  const myCong = useContext(HGContext).globals.cong!;

  type CongOut = {
    id: number;
    name: string;
    disabled: boolean;
  };

  const possibleCongs: CongOut[] = props.congs
    .filter((c) => {
      if (props.excludeMyCong) return props.langGroupId ? c.id !== props.langGroupId : c.id !== myCong.id;
      return true;
    })
    .map((cong) => {
      const dayInfo =
        cong.wm_dow !== myCong.wmdow && !props.hideDOW ? ` [${localizedDayOfWeek(cong.wm_dow, i18n.language)}]` : "";
      return {
        id: cong.id,
        name: CongName(cong) + dayInfo,
        disabled: cong.direct_exchange === SpeakerDirectExchange.Proposed,
      };
    });

  const lastSelectedCong = possibleCongs.find((c) => c.id === props.selected);
  const [selected, setSelected] = useState(lastSelectedCong);
  const selectedCong = props.congs.find((c) => c.id === props.selected);
  const overrideCong = props.congs.find((c) => c.id === props.override);

  const selectCong = (selected: Option[]) => {
    const selectedCongOut = selected[0] as CongOut;
    setSelected(selectedCongOut);
    if (!selectedCongOut) {
      return;
    }
    props.setCong(selectedCongOut.id);
  };

  return (
    <Form.Group>
      <Form.Label className="fw-bolder text-muted mb-1">{t("list.congregation.title")}</Form.Label>
      <Typeahead
        disabled={!canUpdateWeekendSchedules()}
        autoFocus={props.autoFocus}
        onFocus={() => setSelected(undefined)}
        onBlur={() => setSelected(lastSelectedCong)}
        selected={overrideCong ? [overrideCong] : selected ? [selected] : []}
        id="out_cong"
        flip
        options={possibleCongs}
        labelKey="name"
        onChange={selectCong}
        maxResults={100}
        paginationText={t("general.more") + "…"}
      />
      {!!selectedCong && props.hideMeetingTime !== true && <CongWeekendMeetingTime cong={selectedCong} />}
    </Form.Group>
  );
};

// Helper functions and constants that need to be imported
import { localizedDayOfWeek } from "../../../../../helpers/dateHelpers";
import { CongName } from "../../../common";
import { SpeakerDirectExchange } from "../../../../../types/scheduling/weekend";
import { canUpdateWeekendSchedules } from "../../wm_common";
